var symphony = symphony || {};
var prGrid = prGrid || {
	setup: function(cols) {

		if (typeof cols == 'undefined') {
			if ($(window).width() > 768) {
				cols = 4;
			} else if ($(window).width() > 480) {
				cols = 2;
			} else {
				cols = 1;
			}
		}

		$('.pressArchive').css('height', 'auto');

		if (cols > 3 && ($('.pressArchive-single').length == 5 || $('.pressArchive-single').length == 6 || $('.pressArchive-single').length == 9)) {
			cols = 3;
		}
		if (cols > 2 && ($('.pressArchive-single').length == 4)) {
			cols = 2;
		}

		var rows = Math.ceil($('.pressArchive-single').length / cols);

		var width = 100 / cols;
		var height = $('.pressArchive-single').eq(0).outerHeight();

		$('.pressArchive').css('height', (rows * height));

		$('.pressArchive-single').each(function() {
			$(this).removeClass('no-border');
			$(this).css('width', width + '%');
		});
		
		var end = 0;
		var i = 1;
		while (end < $('.pressArchive-single').length) {
			var start = ($('.pressArchive').height() / height) * ((cols * i) - 1);
			end = ($('.pressArchive').height() / height) * (cols * i);

			for (var i = start; i < end; i++) {
				$('.pressArchive-single').eq(i).addClass('no-border');
			}
			i++;
		}
	}
};

;(function() {

	symphony.pressReleaseGrid = function() {

		setTimeout(function() {
			prGrid.setup();
		}, 300);

		$(window).resize(function() {
			prGrid.setup();
		});

	};


})();